import React from 'react';
import { View, Text, StyleSheet } from 'react-native-web';
import PropTypes from 'prop-types';
import Modal from 'modal-enhanced-react-native-web';
import {Button, Spacing, Spinner, SpinnerControl} from "..";


//TODO(Celso): Adicionar props para title e description!

const SpinnerDialogue = (props) => {

    const {
        isModalVisible,
        onClose,
        isFinished,
        titleProps,
        messageProps,
    } = props;


    let message = !isFinished ? "Enviando informações..." : "Processo concluído com sucesso!";
    message = messageProps ? messageProps : message;

    let title = titleProps ? titleProps : "Em Progresso";

    return (
        <Modal
            isVisible={isModalVisible}
            style={styles.modalContainer}
        >
            <View style={styles.backgroundContainer}>

                <Text style={{ textAlign: 'center', fontWeight: 'bold', fontSize: 22, marginBottom: 12 }} >
                    { title }
                </Text>
                <Spacing height={8} />
                <SpinnerControl isFetching={!isFinished} />

                <Text style={{ textAlign: 'center', marginBottom: 12, marginTop: 12 }} >
                    { message }
                </Text>

                {
                    isFinished === true &&
                    <Button
                        text={'Continuar'}
                        onPress={onClose}
                        containerPropsStyle={{ height: 40, margin: 10 }}
                        textPropsStyle={{ fontSize: 14 }}
                    />
                }

            </View>
        </Modal>
    )

};

const styles = StyleSheet.create({
    modalContainer: {
        flex: 1,
        alignSelf: 'center',
        justifyContent: 'center',
        alignItems: 'center'
    },
    backgroundContainer: {
        width: 400,
        backgroundColor: 'white',
        borderRadius: 8,
        padding: 12,
        alignItems: 'center',
        justifyContent: 'center'
    },
    title: {
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: 22,
        marginBottom: 12
    },
    progress: {
        textAlign: 'center',
        marginBottom: 12,
    },
});

SpinnerDialogue.propTypes = {
    isModalVisible: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    isFinished: PropTypes.bool.isRequired,
    messageProps: PropTypes.string,
    titleProps: PropTypes.string,
};

export { SpinnerDialogue };

// Ao utilizar esse componente, deve-se designar 2 states no arquivo desejado. Ex:
// state = { showProgress: false, isSendFinished: false}
// <SpinnerDialogue
//     isModalVisible={this.state.showProgress}
//     isFinished={this.state.isSendFinished}
//     onClose={() => this.setState({ showProgress: false }) }
// />

// Dentro do component que quer que ele ative:
// this.setState({showProgress: true, isSendFinished: false})

// Por motivos de teste implementei um setTimeOut para o spinner ficar durante 3s
// setTimeout(() => {
//     this.setState({isSendFinished: true})
// }, 3000);
